import { Question } from '../../api/services/orders/types.ts'

export const findAnswerTextByExtraValue = (
  questions: Question[],
  extraValue: string
): string | undefined => {
  for (const question of questions) {
    if (
      'extra' in (question.extra_data ?? {}) &&
      (question.extra_data as { extra: string }).extra === extraValue
    ) {
      const firstAnswer = question.answers[0]
      const firstChoice = firstAnswer?.choices[0]
      if (firstChoice?.text) {
        return firstChoice.text
      }
    }
  }
  return undefined
}
